import { DiscussionStatusTag } from '~/lib/discussions/types';

export function DiscussionStatusItem({ text, className }: DiscussionStatusTag) {
  return (
    <span
      role="status"
      className={`rounded-t-sm px-3.5 py-1 text-center text-xs font-semibold capitalize text-white ${className}`}
    >
      {text}
    </span>
  );
}
